import { Link, useParams } from "react-router";
import { Page, PageHeader, Tile } from "../calm.tsx";
import { IdeaStatus, useIdeaRow } from "../components/IdeaStatus.tsx";
import { Empty } from "../ui.tsx";

/** /ideas/:id — where an idea is right now, step by step, live. */
export function IdeaStatusPage() {
  const { id = "" } = useParams();
  const { row, isLoading } = useIdeaRow(id);
  return (
    <Page>
      <PageHeader crumbs={[{ label: "Ideas", to: "/ideas" }]} title={row ? `“${row.intent.problem || row.intent.title}”` : "Idea"} meta={<span>What happens next</span>} />
      <div className="mt-8" data-testid="idea-status-page">
        <Tile span={6}>
          {row ? (
            <>
              <IdeaStatus row={row} />
              <p className="mt-4 text-[13px] text-ink-3">
                <Link to={`/intents/${row.intent.id}`} className="hover:text-ink" data-testid="idea-open-intent">
                  Open the spec and tasks →
                </Link>
              </p>
            </>
          ) : isLoading ? (
            <p className="text-ink-3">Loading…</p>
          ) : (
            <Empty>This idea is not here: it may be cancelled or in another project you cannot see.</Empty>
          )}
        </Tile>
      </div>
    </Page>
  );
}
